<template>
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <h1 class="mb-4">{{ t('pages./contact.title') }}</h1>
        <p class="contact-lead">
          <i18n-t keypath="pages./contact.lead" tag="span">
            <template #email>
              <a :href="`mailto:${EMAIL}`">{{ EMAIL }}</a>
            </template>
          </i18n-t>
        </p>

        <h2 class="contact-heading">{{ t('pages./contact.topics-title') }}</h2>
        <ul class="contact-list">
          <li>{{ t('pages./contact.topic1') }}</li>
          <li>{{ t('pages./contact.topic2') }}</li>
          <li>{{ t('pages./contact.topic3') }}</li>
        </ul>

        <h2 class="contact-heading">{{ t('pages./contact.company-title') }}</h2>
        <p class="contact-body">
          {{ t('pages./contact.company-body') }}
          <a :href="commercePath">{{ t('pages./contact.company-link') }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const { t } = useI18n()
const route = useRoute()

const EMAIL = 'hello@kikuflow.com'

const commercePath = computed(() => {
  const lang = route.params.lang as string | undefined
  return lang ? `/${lang}/commerce` : '/commerce'
})
</script>

<style scoped>
.contact-lead {
  font-size: 1.1rem;
  line-height: 1.9;
  margin-bottom: 2.5rem;
}

.contact-heading {
  font-size: 1.2rem;
  font-weight: 700;
  margin-top: 2.5rem;
  margin-bottom: 0.75rem;
}

.contact-list {
  line-height: 1.9;
  color: #495057;
  padding-left: 1.25rem;
  margin-bottom: 0;
}

.contact-body {
  line-height: 1.9;
  color: #495057;
  margin-bottom: 0;
}
</style>
